<div class="w-100 h-100 d-flex flex-column gap-3 px-0 px-md-4 px-lg-5 py-2">
  <div class="text-center w-100">
    <div class="shadow-lg rounded-4 overflow-hidden w-100 px-lg-5 py-2"
      style="backdrop-filter: blur(10px);background: rgba(255,255,255,0.8);">

      <!-- Loading Overlay -->
      <div class="page-loader" *ngIf="isLoading">
        <div class="loader-content">
          <div class="spinner-wrapper">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-3 loading-text">Preparing Your Workspace...</p>
            <mat-progress-bar mode="indeterminate" class="mt-2"></mat-progress-bar>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="" *ngIf="!isLoading">
        <!-- Progress Tracker -->
        <div class="progress-tracker rounded-4 mt-3">
          <div class="steps-wrapper p-2">
            <div *ngFor="let item of counts; let i = index" class="step-item" [class.completed]="isStepCompleted(item)"
              [class.active]="orderStatus === item" [class.failed]="orderStatus === 'RJ'">
              <span class="circle-desc">{{ item }}</span>
              <div class="circles">
                <mat-icon>
                  {{ getStepIcon(item) }}
                </mat-icon>
              </div>
            </div>
          </div>
        </div>

        <!-- Main Form Section -->
        <div class="form-section mt-4">
          <div class="container">
            <!-- Status Messages -->
            <div class="status-messages mb-4">
              <!-- Success Message -->
              <div *ngIf="orderStatus === 'Completed'" class="congrats-message">
                <div class="alert alert-success text-center py-3">
                  <mat-icon class="success-icon mb-2">check_circle</mat-icon>
                  <h4 class="mb-2">Congratulations!</h4>
                  <p class="mb-0">You passed exam</p>
                  <div class="design-comments mt-3" *ngIf="reviewComments">
                    <h5 class="mb-2">Feedback: {{ reviewComments}}</h5>

                  </div>
                </div>
              </div>

              <!-- Failure Message -->
              <div *ngIf="orderStatus === 'Failed'" class="failure-message">
                <div class="alert alert-danger text-center py-3">
                  <mat-icon class="failure-icon mb-2">cancel</mat-icon>
                  <h4 class="mb-2">Oops!</h4>
                  <p class="mb-0">Sorry, you didn't pass this exam.</p>
                  <div class="design-comments mt-3" *ngIf="reviewComments">
                    <h5 class="mb-2">Feedback: {{ reviewComments }}</h5>
                  </div>
                </div>
              </div>
            </div>

            <form class="custom-form" #userTestForm="ngForm" [class.disabled-form]="!isFormEnabled()">
              <div class="form-header text-center mb-4">
                <h2 class="fw-bold" style="color: #008A70;">Designer Evaluation Test</h2>
                <p class="text-muted">Please complete all required fields marked with an asterisk (*)</p>
              </div>

              <div class="card main-card shadow-sm">
                <div class="card-body p-4">
                  <!-- Designer Selection Section -->
                  <div class="section-block mb-4">
                    <h5 class="section-title d-flex align-items-center">
                      <mat-icon class="me-2">person</mat-icon>
                      Designer Selection
                    </h5>
                    <div class="row g-4">
                      <div class="col-md-6">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Select Designer Level *</mat-label>
                          <mat-select [(value)]="designerLevel" required [disabled]="status != 'ST' || hasDownloaded">
                            <mat-option *ngFor="let tier of tiers | keyvalue" [value]="tier.key">
                              {{ tier.value }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-md-6">
                        <button *ngIf="designerLevel"
                          class="customPreActivatedButtons w-100 d-flex align-items-center justify-content-center gap-2"
                          (click)="downloadFiles()" [disabled]="status != 'ST' || hasDownloaded">
                          <mat-icon>download</mat-icon>
                          <span>{{ status != 'ST' || hasDownloaded ? 'Files Downloaded' : 'Download Test Files'
                            }}</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- File Upload Section with Inline Progress -->
                  <div class="section-block mb-4">
                    <h5 class="section-title d-flex align-items-center">
                      <mat-icon class="me-2">cloud_upload</mat-icon>
                      File Upload
                    </h5>
                    <div class="upload-zone rounded border-2 border-dashed p-4">
                      <div class="upload-content text-center">
                        <div class="d-flex align-items-center justify-content-center gap-3">
                          <button type="button" class="customPreActivatedButtons d-inline-flex align-items-center gap-2"
                            (click)="fileInput.click()" [disabled]="status != 'IP'">
                            <mat-icon>file_upload</mat-icon>
                            <span>Browse Files</span>
                          </button>

                          <!-- Inline Progress Bar -->
                          <div class="progress-section flex-grow-1" *ngIf="uploadProgress > 0 && uploadProgress < 100">
                            <div class="progress">
                              <div class="progress-bar" role="progressbar" [style.width.%]="uploadProgress">
                                {{uploadProgress}}%
                              </div>
                            </div>
                          </div>
                        </div>

                        <input type="file" #fileInput (change)="onFileUpload($event)" multiple hidden>
                        <p class="text-muted mt-2 mb-0">or drag and drop files here</p>
                      </div>
                    </div>

                    <!-- Uploaded Files List -->
                    <div class="file-list mt-3">
                      <div *ngFor="let file of uploadedFiles; let i = index"
                        class="file-item d-flex align-items-center p-2 mb-2">
                        <mat-icon class="me-2">description</mat-icon>
                        <span class="flex-grow-1">{{ file }}</span>
                        <button mat-icon-button class="btn-icon" (click)="removeFile(i)" [disabled]="status != 'ST'">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>

                      <!-- No Files Message -->
                      <div *ngIf="uploadedFiles.length === 0" class="text-muted text-center p-3">
                        No files uploaded yet
                      </div>
                    </div>
                  </div>

                  <!-- Comments Section -->
                  <div class="section-block">
                    <h5 class="section-title d-flex align-items-center">
                      <mat-icon class="me-2">comment</mat-icon>
                      Additional Comments
                    </h5>
                    <div class="comments-section">
                      <textarea class="customInputFields" rows="4"
                        placeholder="Share any specific requirements or instructions..." [(ngModel)]="designComments"
                        name="designComments" [disabled]="status != 'IP'">
                </textarea>
                    </div>
                  </div>

                  <!-- Submit Section -->
                  <div class="submit-section text-center mt-4">
                    <button type="button" (click)="onSubmit()"
                      class="customPreActivatedButtons d-inline-flex align-items-center gap-2"
                      [disabled]="!isFormEnabled() || !userTestForm.form.valid || uploadedFiles.length === 0">
                      <mat-icon>send</mat-icon>
                      <span>Submit Evaluation</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>